import { PaymentType } from "@/lib/Types/DateListResponse/PaymentType";

/**
 * Transforms availablePaymentTypes array into a flat array of payment type strings.
 * For CreditCard types, extracts the credit card codes (VI, MC, AX, etc.).
 * For other types (BankTransfer, DirectDebitSEPA, Paypal), uses the type directly.
 *
 * @param availablePaymentTypes - Array of PaymentType objects from vacancy response
 * @returns Array of payment type strings for display
 */
export const getPaymentTypes = (
  availablePaymentTypes: PaymentType[] | undefined | null
): string[] => {
  if (!availablePaymentTypes || availablePaymentTypes.length === 0) {
    return [];
  }

  return availablePaymentTypes.map((paymentType) => {
    if (
      paymentType.type === "CreditCard" &&
      paymentType.creditCards &&
      paymentType.creditCards.length > 0
    ) {
      // For CreditCard type, return the specific card code (VI, MC, AX, etc.)
      return paymentType.creditCards[0];
    }
    // For other types (BankTransfer, DirectDebitSEPA, Paypal, etc.), return the type
    return paymentType.type;
  });
};
